import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import CbsCstService from './cbsCstService'
import FormList from 'base/FormList'

export default function CbsCstList() {

    const [service] = useState(() => new CbsCstService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_cbscst',
        dsName: 'descricao_cbscst',
        mainField: { name: 'descricao_cbscst', label: 'Descrição' },
        advFields: [
            { name: 'codigo_cbscst', label: 'Código', type: 'string', inputMode: 'text' },
            { name: 'descricao_cbscst', label: 'Descrição', type: 'string', inputMode: 'text' },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="codigo_cbscst" sortable header="Código"></Column>
            <Column field="descricao_cbscst" sortable header="Descrição"></Column>
        </FormList>
    )
}
